import './home-visual.css'

const HomeVisual = () => {

    return (
        <div className='home-visual'>
            

            <div className='slogan-text'>
                <h1 className="home-intro">Yichi Zhang</h1>
                <div className='divider'></div>
                <h3 className='home-sub-intro'>I handle web. Yes, the whole Internet</h3>
            </div>

            <div className='scroll-down-container'>
                <span className="scroll-down-text">Scroll Down</span>
                <i className="zoom icon mouse fas fa-mouse"></i>
                <i className="zoom icon finger fa fa-hand-o-down"></i>
            </div>

            <div className='icon-container'>
                <a href='https://github.com/azerous1' className='icon zoom fab fa-github'>{}</a>
                <a href='https://www.linkedin.com/in/yichi-zhang-107bba173/' className='icon zoom fab fa-linkedin'>{}</a>
            </div>
        </div>
    )
}

export default HomeVisual;